<template>
  <div>
    <PageHeader :schema="$schemas.reseller" />
    <PageContent>
      <DynamicFormPage :schema="$schemas.reseller" :service="$api.resellers" />
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import DynamicFormPage from '@/components/dynamics/DynamicFormPage';

export default {
  name: 'CreateReseller',
  components: { PageHeader, PageContent, DynamicFormPage },
};
</script>
